import { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, ReferenceLine } from "recharts";
import { Users } from "lucide-react";
import { http } from "../lib/api";

export function PlannedAgentsChart() {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => http.get("/superadmin/planned-agents").then((r) => setD(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);
  if (!d) return null;
  const nowLabel = d.hours[d.current_hour]?.hour;
  return (
    <div className="bg-white border border-slate-200 rounded-md p-5" data-testid="planned-agents-chart">
      <div className="flex flex-wrap items-end gap-x-6 gap-y-2 mb-3">
        <div>
          <h2 className="font-display font-bold text-lg flex items-center gap-2"><Users className="h-5 w-5" />Agents planifiés sur la plateforme</h2>
          <p className="text-xs text-slate-500">Aujourd'hui, toutes entreprises clientes · actualisé chaque minute</p>
        </div>
        <div className="ml-auto flex items-center gap-6">
          <div className="text-right"><div className="text-[11px] font-bold uppercase tracking-wider text-slate-500 inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />En service maintenant</div>
            <div className="font-display text-3xl font-extrabold" data-testid="planned-agents-now">{d.now}</div>
            <div className="text-xs text-slate-500" data-testid="planned-agents-companies">{d.companies_now} entreprise(s)</div></div>
          <div className="text-right"><div className="text-[11px] font-bold uppercase tracking-wider text-slate-500">Pic du jour</div>
            <div className="font-display text-3xl font-extrabold text-slate-400" data-testid="planned-agents-peak">{d.peak}</div></div>
        </div>
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={d.hours} margin={{ top: 18, right: 8, left: 0, bottom: 0 }}>
            <defs><linearGradient id="paFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#0B2A7A" stopOpacity={0.35} /><stop offset="100%" stopColor="#0B2A7A" stopOpacity={0.02} /></linearGradient></defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
            <XAxis dataKey="hour" tick={{ fontSize: 11 }} interval={1} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={36} />
            <Tooltip formatter={(v) => [`${v} agent(s)`, "Planifiés"]} />
            {nowLabel && <ReferenceLine x={nowLabel} stroke="#C9962E" strokeDasharray="4 3" label={{ value: "maintenant", position: "top", fontSize: 10, fill: "#C9962E" }} />}
            <Area type="monotone" dataKey="count" stroke="#0B2A7A" strokeWidth={2} fill="url(#paFill)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
